/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Export_ButtonInputs */



/**
* | output |
* | --- |
* | "Export" |
*
* @param {Dialogue_List_Export_Export_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_export_button = /** @type {((inputs?: Dialogue_List_Export_Export_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Export_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter")
	if (locale === "de") return /** @type {LocalizedString} */ ("Export")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("出口")
	if (locale === "ja") return /** @type {LocalizedString} */ ("輸出")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportar")
	return /** @type {LocalizedString} */ ("Export")
});